<small>{{entry.author}}</small>
<div class="entry-text" [innerHtml]="entry.entryText | unsafeHtml"></div>
<small><em>{{entry.created | langDate}}</em></small>
@if (isAdmin) {
  <button class="pm-delete-entry" mat-icon-button tabindex="1" (click)="delete.emit()"><mat-icon>delete</mat-icon></button>
}
